import React, { useState, useEffect } from "react";
import { fetchApi } from "../../../utils/DatabaseHelper";
import { MITARBEITER_UEBERSICHT } from "../../../utils/TableConstanten";
import { Cell, Label, Pie, PieChart } from "recharts";
import { CustomLabel } from "./CustomLabel";
import logger from "../../../logging/logger";

const DonutChart = ({ color }) => {
    const defaultData = [
      { title: 'red', value: 1, color: color.red },
      { title: 'yellow', value: 1, color: color.yellow },
      { title: 'green', value: 1, color: color.green },
    ];

    const [data, setData] = useState(defaultData);
    const [maxUntersuchungen, setMaxUntersuchungen] = useState(0);
    const [activeIndex, setActiveIndex] = useState(null);

    const validate = () => {
        setData(defaultData);
        setMaxUntersuchungen(0);
        
        fetchApi(MITARBEITER_UEBERSICHT).then(response => {
            let data = response.data;
            var summen = data.reduce(function(akkumulator, obj) {
                return {
                    red: akkumulator.red + obj.red,
                    yellow: akkumulator.yellow + obj.yellow,
                    green: akkumulator.green + obj.green,
                }
            }, {red: 0, yellow: 0, green: 0 });

            let pie_data = []
            Object.entries(summen).forEach(([key, value]) => {
                if(value !== 0){
                    pie_data = [...pie_data, {title: key, value: value, color: color[key]}]
                }
            })
            
            if (Array.isArray(pie_data) && pie_data.length === 0) {
                logger.log("leer");
                pie_data = [{ title: 'NaN', value: 0, color: 'lightgrey'}]
            }

            setData(pie_data);
            
            const total = pie_data.reduce(function(sum, current) {
                return sum + current.value;
            }, 0);
            
            setMaxUntersuchungen(total);
        });
    }

    useEffect(() => {
        localStorage.removeItem("detailSort"); // beim Mount entfernen, da wir ein neuen Sprung haben könnten
        validate();
        
        // Event-Handler für das REFRESH_DASHBOARD-Event
        const handleRefreshDashboard = () => {
            validate();
        };
        
        // Füge Event-Listener hinzu
        global.emitter.on('REFRESH_DASHBOARD', handleRefreshDashboard);
        
        // Entferne Event-Listener beim Unmounting
        return () => {
            global.emitter.off('REFRESH_DASHBOARD', handleRefreshDashboard);
        };
    }, []);

    const onMouseEnter = (data, index) => {
        setActiveIndex(index);
    };

    const onMouseLeave = () => {
        setActiveIndex(null);
    };

    const setSelected = (index) => {
        localStorage.setItem('detailSort', data[index].title);
        window.location.hash = "#vorsorgenkartei";
    }

    return (
        <div className="d-flex align-items-center justify-content-center col">
            <div className="row widget-piechart">
                <div className="col">
                    <PieChart width={275} height={300}>
                        <Pie name="filler" data={[{value:100, name: "all"}]} dataKey="value" outerRadius={70} stroke="none" fill="#fff" />
                        <Pie 
                            data={data} 
                            dataKey="value" 
                            nameKey="name" 
                            stroke="none"
                            innerRadius={80} 
                            outerRadius={100} 
                            onMouseEnter={onMouseEnter}
                            onMouseLeave={onMouseLeave}
                            onClick={(_, index) => setSelected(index)}
                            fill="#82ca9d">
                                {data.map((entry, index) => (
                                    <Cell 
                                        key={`cell-${index}`} 
                                        fill={entry.color} 
                                        opacity={index === activeIndex ? '0.6' : '1'} 
                                        cursor={"pointer"}
                                    />
                                ))}
                            <Label width={30} position="center"
                                content={<CustomLabel value1={maxUntersuchungen} value2="UNTERSUCHUNGEN"/>}>
                            </Label>
                        </Pie>
                    </PieChart>
                </div>
                <div className="col-auto d-flex align-items-center">
                    <div className="pie-legend">
                        {   
                            data.map((entry, idx) => {
                                let text = {red: "FÄLLIG", yellow: "BALD FÄLLIG", green: "GÜLTIG"}
                                return (
                                    <div key={entry.title} onClick={() => setSelected(idx)}>
                                        <label className="txt-caps-small-regular">{text[entry.title]}</label>
                                        <p>
                                            <span className={`legend-color ${entry.title}`} />
                                            <span>{entry.value}</span>
                                        </p>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DonutChart;
